const routes = {
  landing: {
    name: 'דף נחיתה',
    path: '/landing',
  },
  landingWithAgent: {
    name: 'דף נחיתה',
    path: '/landing/:agentId',
  },
  main: {
    name: 'דף ראשי',
    path: '/main',
  },
  login: {
    name: 'התחברות',
    path: '/:proposalNumber',
  },
  otp: {
    name: 'סיסמא',
    path: '/otp',
  },
  summary: {
    name: 'סיכום הצעה',
    path: '/summary',
  },
  mortgageCycleSummary: {
    name: 'סיכום שיפור משכנתא קיימת',
    path: '/mortgageCycleSummary',
  },
  agree: {
    name: 'תנאי ההסכם',
    path: '/agree',
  },
  termsOfUse: {
    name: 'תנאי השימוש',
    path: '/termsOfUse/:clientId',
  },
  successAgreeTerms: {
    name: 'הסכמה לתנאי השימוש - הצלחה',
    path: '/successAgreeTerms',
  },
  pay: {
    name: 'תשלום',
    path: '/pay',
  },
  paymentError: {
    name: 'שגיאת תשלום',
    path: '/paymentError',
  },
  success: {
    name: 'הצלחה',
    path: '/success',
  },
};

export default routes;
